import apiClient from './apiClient';

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const API_URL = `${BASE_URL}/api/v1/ue-expenses`;

class UeExpensesService {
    getList(params: any, expenseType: string) {
        return apiClient.post(`${API_URL}/list?type=${expenseType}`, params).then(response => response.data);
    }

    getById(uuid: string) {
        return apiClient.get(`${API_URL}/${uuid}`).then(response => response.data);
    }

    create(data: any, expenseType: string) {
        return apiClient.post(`${API_URL}?type=${expenseType}`, data).then(response => response.data);
    }

    update(data: any) {
        return apiClient.put(API_URL, data).then(response => response.data);
    }

    exportExcel(uuid: string) {
        return apiClient.get(`${API_URL}/export-excel/${uuid}`, { responseType: 'blob' });
    }

    deleteById(uuid: string) {
        return apiClient.delete(`${API_URL}/${uuid}`).then(response => response.data);
    }
    getDefaultYears() {
        const trancheYears = [];
        const currentYear = new Date().getFullYear();
        for (let i = 2019; i <= currentYear + 1; i++) {
            trancheYears.push(i);
        }
        return trancheYears;
    }
}

export default new UeExpensesService();
